// WhyChooseUsSection.jsx
import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5, staggerChildren: 0.12 } },
};
const row = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export default function WhyChooseUsSection() {
  const img = `${process.env.PUBLIC_URL || ""}/images/chooseus.jpg`;

  return (
    <motion.section
      className="bg-white py-12 md:py-16 font-sans"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.35 }}
      variants={container}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        {/* Heading */}
        <motion.h2
          className="text-3xl md:text-5xl font-bold text-black text-center mb-8 md:mb-10"
          style={{ fontFamily: "Inter, sans-serif" }}
          variants={row}
        >
          Why choose us?
        </motion.h2>

        {/* Single image (no crop, fits one screen on mobile) */}
        <motion.figure
          className="relative w-full max-w-5xl mx-auto rounded-3xl overflow-hidden shadow-xl"
          variants={row}
          whileHover={{ scale: 1.005 }}
          transition={{ type: "spring", stiffness: 220, damping: 22 }}
        >
          <img
            src={img}
            alt="Why choose us visual"
            className="block w-full h-auto max-h-[58vh] sm:max-h-[62vh] md:max-h-[66vh]"
            loading="lazy"
            decoding="async"
            draggable="false"
          />
          <figcaption className="sr-only">Why choose us visual</figcaption>
        </motion.figure>
      </div>
    </motion.section>
  );
}
